/**
 * 서브도메인별 설정
 * 새 서브도메인 추가 시 이 파일에만 항목을 추가하면 됩니다.
 *
 * 키값: 서브도메인 이름(test.nicelinker.kr일 경우 "test")
 * menus: 브레드크럼 MENUS 키 형식과 동일
 *   - title: GNB/브레드크럼 상위 항목명
 *   - path: 대표 경로
 *   - submenus: [{ name, path, isHide? }]
 */
const subdomainConfig = {
  // CTP 수출지원서비스 (ctp.nicelinker.kr)
  ctp: {
    menus: {
      BIG_BUYER_MARKETING: {
        title: "AI 수출플랫폼",
        path: "/bm/big-data",
        submenus: [
          { name: "빅데이터 바이어 발굴", path: "/bm/big-data" },
          { name: "마케팅 메시지 발송", path: "/bm/push", isHide: true },
          { name: "마케팅 메시지 발송내역", path: "/bm/history" },
          { name: "임시저장내역", path: "/bm/tmp" },
        ],
      },
      // APPLY: {
      //   title: "세계화 지원사업",
      //   path: "/ctp-apply",
      //   submenus: [
      //     { name: "참가신청", path: "/ctp-apply" },
      //     { name: "신청내역", path: "/ctp-apply/history" },
      //     { name: "신청상세", path: "/ctp-apply/detail", isHide: true },
      //   ],
      // },
      MYPAGE: {
        title: "마이페이지",
        path: "/mypage",
        submenus: [
          { name: "마이페이지", path: "/mypage" },
          { name: "정보수정", path: "/update-info", isHide: true },
          { name: "캐시 내역", path: "/cash-history" },
          { name: "문의내역", path: "/contact-history" },
        ],
      },
      CS: {
        title: "고객센터",
        path: "/cs-notices",
        submenus: [
          { name: "공지사항", path: "/cs-notices" },
          { name: "FAQ", path: "/cs-faq" },
          { name: "문의하기", path: "/cs-contacts" },
        ],
      },
    },
  },
};

export default subdomainConfig;
